module.exports = __webpack_public_path__ + "img/1527143647.03cb42c4.jpg";